




























import Vue from "vue";
import { myCertificates } from "@/api/my";
import _ from "lodash";
import MyCertificatesCard from "@/views/my/MyCertificatesCard.vue";
import { ignoredTests } from "html2canvas/dist/types/build/reftests";
import { datetimeFormat, html2imgDataUrl } from "@/utils/lang";
import { $constants } from "@/scripts/constants";

export default Vue.extend({
    name: "MyCertificates",
    components: { MyCertificatesCard },
    computed: {
        noneData(): boolean {
            return _.isEmpty(this.certificatesList);
        },
        certificateImages(): any {
            return _.map(this.certificatesList, certificate => certificate.img);
        }
    },
    data() {
        return {
            loading: true,
            finished: false,
            certificatesList: new Array(0),
            showPreview: false,
            previewIndex: 0
        };
    },
    mounted() {
        this.doQuery();
    },
    methods: {
        onLoad() {
            this.doQuery();
        },
        doQuery() {
            this.loading = true;
            myCertificates()
                .then(resp => {
                    if (resp.data) {
                        this.certificatesList = this.mapperCertificates(resp.data.data);
                        this.$nextTick(() => {
                            this.generateCertificatesList(this.certificatesList);
                        });
                    }
                })
                .catch()
                .finally(() => {
                    this.loading = false;
                });
        },
        mapperCertificates(certificatesList) {
            return _.map(certificatesList, certificate => {
                return {
                    id: certificate.id,
                    certificateType: certificate.certificateTemplateType,
                    certificateStyle: certificate.certificateStyle,
                    klassNames: certificate.klassNames,
                    awardDate: datetimeFormat(certificate.awardDate, $constants.DATE_FMT)
                };
            });
        },
        generateCertificatesList(certificatesList) {
            const promises = _.map(certificatesList, async certificate => {
                const newCertificate = _.merge({}, certificate);
                newCertificate.img = await html2imgDataUrl(certificate.certificateStyle);
                return newCertificate;
            });
            Promise.all(promises)
                .then(certificates => {
                    this.certificatesList = certificates;
                })
                .catch();
        },
        preview(index): void {
            this.showPreview = true;
            this.previewIndex = index;
            this.$router.push(this.$route.path + "#preview");
        },
        onClosePreview(): void {
            if (this.$route.hash === "#preview") {
                this.$router.back();
            }
        }
    }
});
